const SDK_VERSION = '7.119.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
